import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<HttpError @code={{this.model.status}} as |Error|>\n  <Error.LinkStandalone @icon=\"chevron-left\" @iconPosition=\"leading\" @text={{t \"helpers.options-for-http-error.go-back\"}} @route=\"application\" data-test-error-link />\n</HttpError>", {
  moduleName: "vagrant/templates/error.hbs"
});